import React from 'react';
import PropTypes from 'prop-types';
import { BundleRoute } from '@saucelabs/sl-component-router';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';
import dynamic from '@redux-dynostore/react-redux';
import { attachReducer } from '@redux-dynostore/core';
import { SentryBoundary } from '@saucelabs/sl-component-sentry';
import { constants as sentryConstants } from '@saucelabs/sl-util-sentry';

import archivesReducer from './reducers';

const importArchives = () => import(/* webpackChunkName: "archives" */ './containers/ArchivesContainer');

const ArchivesRoutes = ({ match }) => (
  <LoginRequiredContainer>
    <SentryBoundary owner={sentryConstants.TEAMS.PERFORMANCE}>
      <BundleRoute
        load={importArchives}
        path={`${match.url}`}
      />
    </SentryBoundary>
  </LoginRequiredContainer>
);

ArchivesRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};

export default dynamic(
  'apps.archives', attachReducer(archivesReducer),
)(ArchivesRoutes);
